import { render } from "./theme5.vue?vue&type=template&id=0b314f96&scoped=true"
import script from "./theme5.vue?vue&type=script&lang=js"
export * from "./theme5.vue?vue&type=script&lang=js"

import "./theme5.vue?vue&type=style&index=0&id=0b314f96&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0b314f96"

export default script